import Filter from "./features/Filter";
import List from "./features/List";
import {useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {DeadlineFilterItemType, DeadlineListElementType, DeadlineSearchParamType} from "./interface";
import {deadlineFilterItemInit, deadlineListMapInit, deadlineSearchParamInit} from "./state";
import {useReadDeadlineList} from "./hooks/useReadDeadlineList";
import {useReadTaxEndDate} from "./hooks/useReadTaxEndDate";
import {useForm, useWatch} from "react-hook-form";
import useGoToNavigation from "../../../../util/useGotoNavigation";
import {useSaveTaxEndDate} from "./hooks/useSaveTaxEndDate";
import {useSaveDeadlineExchange} from "./hooks/useSaveDeadlineExchange";
import {useModal} from "../../../../hooks";
import {useQueryClient} from "@tanstack/react-query";
import moment from "moment/moment";

export default function DeadlineList() {
    const page = Number(useSearchParams()[0].get("pageNo")) || 1;
    const {goToNavigation} = useGoToNavigation();
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const [searchParam, setSearchParam] = useState<DeadlineSearchParamType>((() => ({
        ...deadlineSearchParamInit,
        fromDate: moment().subtract(1, "months").startOf("months").format("YYYY-MM-DD"),
        toDate:  moment().endOf("month").format("YYYY-MM-DD"), // 당월 말일
    }))())
    const [filterItem, setFilterItem] = useState<DeadlineFilterItemType>(deadlineFilterItemInit)

    const {data: deadline} = useReadDeadlineList({param: searchParam});
    const {data: taxEndDate} = useReadTaxEndDate()
    const {mutate: mutateSaveTaxEndDate} = useSaveTaxEndDate()
    const {mutateAsync: mutateAsyncSaveDeadlineExchange} = useSaveDeadlineExchange()

    const [selectedItems, setSelectedItems] = useState<DeadlineListElementType[]>([])

    const {register, handleSubmit, control, getValues, setValue} = useForm({
        defaultValues: searchParam,
    });

    const {
        register: registerFilter,
        handleSubmit: handleSubmitFilter,
        control: controlFilter,
        getValues: getValuesFilter,
        setValue: setValueFilter,
    } = useForm({
        defaultValues: filterItem,
    });

    const watchSearchParam = {
        ...searchParam,
        ...useWatch<DeadlineSearchParamType>({control})
    }

    const watchFilterItem = {
        ...filterItem,
        ...useWatch<DeadlineFilterItemType>({control: controlFilter})
    }

    const btnSearch = () => {
        goToNavigation(`order/deadline/list?pageNo=1`, {}, false)
        setSearchParam({...watchSearchParam, pageNo: 1});
        setSelectedItems([])
    };

    const btnSaveTaxEndDate = () => {
        handleModal({
            isOpen: true,
            contents: "저장하시겠습니까?",
            type: "confirm",
            callback: () => mutateSaveTaxEndDate(watchFilterItem)
        });
    }

    const btnApplyExchangeRate = () => {
        const callback = () => {
            const list = selectedItems.map(el => ({...el, newDExchangeRate: watchFilterItem.newDExchangeRate}))

            mutateAsyncSaveDeadlineExchange(list).then(res => {
                if (res.data.code === "0000") {
                    handleModal({
                        isOpen: true,
                        contents: "적용되었습니다",
                        type: "alert",
                    });

                    qc.invalidateQueries({queryKey: ["readDeadlineList"]})
                    setSelectedItems([])
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.msg,
                        type: "alert",
                    });
                }
            })
        }

        if (selectedItems.length === 0) {
            handleModal({
                isOpen: true,
                contents: "항목을 선택해주세요.",
                type: "alert",
            });
        } else {
            handleModal({
                isOpen: true,
                contents: "적용하시겠습니까?",
                type: "confirm",
                callback: () => callback()
            });
        }
    }

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: page})
    }, [page]);

    useEffect(() => {
        if (taxEndDate) {
            setFilterItem({...filterItem, ...taxEndDate})
            setValueFilter("taxEndDateId", taxEndDate.taxEndDateId)
            setValueFilter("taxEndDate", taxEndDate.taxEndDate)
        }
    }, [taxEndDate]);

    return <>
        <Filter watchSearchParam={watchSearchParam}
                register={register}
                watchFilterItem={watchFilterItem}
                registerFilter={registerFilter}
                btnSearch={btnSearch}
                btnSaveTaxEndDate={btnSaveTaxEndDate}
                btnApplyExchangeRate={btnApplyExchangeRate}
                controlFilter={controlFilter}
        />

        <List searchParam={searchParam}
              deadline={deadline ?? deadlineListMapInit}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems}
        />
    </>
}